<template>
  <section class="vbox">    
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/">系统</a></el-breadcrumb-item>
          <el-breadcrumb-item>全局参数</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form ref="form" v-model="form" label-width="200px" size="medium">
        <el-form-item label="积分价值">
          <el-col :span="8">
            <el-tooltip class="item" effect="dark" content="请勿随意更改该值" placement="right">
              <el-input v-model="form.pointPrice" >
                <el-button slot="append" >分=1元</el-button>
              </el-input>
            </el-tooltip>            
          </el-col>
        </el-form-item>
        <el-form-item label="商家信用额度">
          <el-col :span="8">            
            <el-tooltip class="item" effect="dark" content="开通联盟功能后使用" placement="right">
              <el-input v-model="form.creditLine" >
                <el-button slot="append" >元</el-button>
              </el-input>
            </el-tooltip>
          </el-col>
        </el-form-item>        
        <!-- <el-form-item label="运营模式">
          <el-col :span="8">
            <el-select v-model="form.operateMode" placeholder="请选择运营模式">
              <el-option
                v-for="item in modes"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>     
          </el-col>     
        </el-form-item> -->
        <el-form-item label="会员注册赠送Vip">
          <el-col :span="8">            
            <el-input v-model="form.memberRegisterGiftVip" >
              <el-button slot="append" >天</el-button>
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="会员注册赠送积分">
          <el-col :span="8">            
            <el-input v-model="form.memberRegisterGiftPoint" >
              <el-button slot="append" >分</el-button>
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="推介会员注册赠送积分">
          <el-col :span="8">            
            <el-input v-model="form.recommendMemberRegisterGiftPoint" >
              <el-button slot="append" >分</el-button>
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="用户付款方式">
          <el-col :span="20">
            <el-checkbox-group v-model="memberPaidWayCheckList">
              <el-checkbox label="微信" name="memberPaidWay"></el-checkbox>
              <el-checkbox label="支付宝" name="memberPaidWay"></el-checkbox>
              <el-checkbox label="积分" name="memberPaidWay"></el-checkbox>
              <el-checkbox label="奖励金" name="memberPaidWay"></el-checkbox>
              <el-checkbox label="余额" name="memberPaidWay"></el-checkbox>
              <!-- <el-checkbox label="代金券" name="memberPaidWay"></el-checkbox> -->
              <el-checkbox label="其他" name="memberPaidWay"></el-checkbox>
            </el-checkbox-group>
          </el-col>
        </el-form-item>
        <el-form-item label="操作员收款方式">
          <el-col :span="20">
            <el-checkbox-group v-model="userPaidWayCheckList">
              <el-checkbox label="微信" name="userPaidWay"></el-checkbox>
              <el-checkbox label="支付宝" name="userPaidWay"></el-checkbox>
              <el-checkbox label="积分" name="userPaidWay"></el-checkbox>
              <el-checkbox label="奖励金" name="userPaidWay"></el-checkbox>
              <el-checkbox label="余额" name="userPaidWay"></el-checkbox>
              <el-checkbox label="现金" name="userPaidWay"></el-checkbox>
              <!-- <el-checkbox label="代金券" name="userPaidWay"></el-checkbox> -->
              <el-checkbox label="其他" name="userPaidWay"></el-checkbox>
            </el-checkbox-group>
          </el-col>
        </el-form-item>
        <el-form-item label="线上支付默认到商家">
          <el-col :span="12">
            <el-switch
              v-model="form.onLinePaytoBusiness">
            </el-switch>
          </el-col>
        </el-form-item>
        <el-form-item label="淘宝联盟Appkey">
          <el-col :span="8">            
            <el-input v-model="form.taoBaoLianMengAppkey" >
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="淘宝联盟AppSecret">
          <el-col :span="8">            
            <el-input v-model="form.taoBaoLianMengAppSecret" >
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="淘宝联盟AdzoneId">
          <el-col :span="8">            
            <el-input v-model="form.adzoneId" >
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="大淘客Appkey">
          <el-col :span="8">
            <el-input v-model="form.daTaoKeAppKey" >
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="大淘客AppSecret">
          <el-col :span="8">
            <el-input v-model="form.daTaoKeAppSecret" >
            </el-input>
          </el-col>
        </el-form-item>
        
        <el-form-item label="拼多多client_id">
          <el-col :span="8">
            <el-input v-model="form.ddk_client_id" >
            </el-input>
          </el-col>
        </el-form-item>
        
        <el-form-item label="拼多多client_secret">
          <el-col :span="8">
            <el-input v-model="form.ddk_client_secret" >
            </el-input>
          </el-col>
        </el-form-item>
        
        <el-form-item label="拼多多默认pid">
          <el-col :span="8">
            <el-input v-model="form.ddk_default_pid" >
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="微信小程序Appid">
          <el-col :span="8">
            <el-input v-model="form.weChat_MiniProgram_appid" >
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="微信小程序AppSecret">
          <el-col :span="8">
            <el-input v-model="form.weChat_MiniProgram_APPSECRET" >
            </el-input>
          </el-col>
        </el-form-item>        
        <el-form-item label="腾讯地图key">
          <el-col :span="8">
            <el-input v-model="form.qqMapKey" >
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item >
          <el-col :span="11">
            <el-button type="primary" @click="Save">确 定</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </section>    
  </section>
</template>
<script  type='text/ecmascript-6'>
  import qs from 'qs' 
  export default {
    props:{
    },
    data (){
      return {
        form:{},
        memberPaidWayCheckList: [], 
        userPaidWayCheckList:[],
        modes:[{
          id:'0',
          name:'展示模式'
        },{
          id:'1',
          name:'抽成模式'
        }]
        
      }
    },
    components:{
    },
    computed:{
    },
    mounted(){
      var that = this
      this.axios({
        method:'get',
        url:that.global.serverSrc + '/api/System/ParameterIndex',         
        params:{          
        }
      }).then(function (resp) {
        that.form = resp.data.data
        that.memberPaidWayCheckList = resp.data.data.memberPaidWay.split(',');
        that.userPaidWayCheckList = resp.data.data.userPaidWay.split(',');
      })
    },
    methods:{     
      Save:function(){
        var that = this
        that.form.memberPaidWay = this.memberPaidWayCheckList.toString()
        that.form.userPaidWay = this.userPaidWayCheckList.toString()
        var dataObj = qs.stringify(that.form)

        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/System/SaveParameter',         
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },        
          data:dataObj
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);
          }else {
            that.$message.warning(resp.data.message);
          }  
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
  .content-header
    padding 24px
    border 1px solid #C0C4CC
    margin-bottom 24px
</style>